import { Vue, Component, Prop } from 'vue-property-decorator';
import TeacherClassesList from '@/components/rosters-pages/teacher-classes-list/teacher-classes-list';

@Component({
    name: 'slide-popup-layout',
    components: {
        'roster-popup': () => import('@/routers/views/setup/roster-setup/roster-request/roster-sync-view/roster-sync-view.vue'),
        'roster-table-pullup': () => import('@/routers/views/setup/roster-setup/roster-views/roster-table-view/roster-table-pullup/roster-table-pullup.vue'),
        'user-class-table': () => import('@/components/rosters-pages/user-classes-list/user-classes-list.vue'),
        'teacher-classes-list': TeacherClassesList,
    },
})

export default class SlidePopupLayout extends Vue {

    // ----------------------------------------------------------------
    // Properties

    @Prop({ default: 'roster-popup' })
    private activeComponent?: string;

    @Prop({ default: null })
    private eventBind: any;

    @Prop({ default: null })
    private propBind: any;

    @Prop({ default: 'Details' })
    private cardName: any;

    private selectedCardName: any = {
        userClasses: 'User Classes',
        teacherClasses: 'Teacher Classes',
        details: 'Details',
    };

    private activeCardName: any;

    @Prop()
    private selectedTeacher: any;

    // -----------------------------------------------------------------
    // Action

    private created() {
        this.activeCardName = this.cardName;
    }

    private mounted() {
        document.addEventListener('keydown', ({key}) => {
            if (key === 'Escape') {
                this.onCloseNow();
            }
        });
    }

    private onClose() {
        if (this.activeComponent === 'teacher-classes-list') {
            this.activeCardName = this.selectedCardName.userClasses;
            this.$emit('onSelectComponent', 'user-class-table', this.propBind.selectedRow);
        } else {
            this.$emit('onClose');
        }
    }

    private onCloseNow() {
        this.$emit('onClose');
    }

    private onSelectComponent(component: any, selectedTeacher: any) {
        this.activeCardName = this.selectedCardName.teacherClasses;
        this.$emit('onSelectComponent', component, selectedTeacher);

    }

}
